import { render, staticRenderFns } from "./InspectionListAttachmentsViewer.vue?vue&type=template&id=128cb92b&scoped=true"
import script from "./InspectionListAttachmentsViewer.vue?vue&type=script&lang=ts"
export * from "./InspectionListAttachmentsViewer.vue?vue&type=script&lang=ts"
import style0 from "./InspectionListAttachmentsViewer.vue?vue&type=style&index=0&id=128cb92b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128cb92b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VDialog,VImg})
